export default __webpack_public_path__ + "static/media/silver.74be2233.png";